module.exports = "<p class=\"preserve-whitespaces-wrap\">{{$data}}</p>\n";
